import {combineReducers} from '@reduxjs/toolkit';

import {datasetEntitlementsStateSlice} from './slices/dataset-entitlements-state.slice';
import {datasetEntitlementsSlice} from './slices/dataset-entitlements.slice';

export const datasetEntitlementsReducer = combineReducers({
    entitlements: datasetEntitlementsSlice.reducer,
    state: datasetEntitlementsStateSlice.reducer,
});
